import type { RTBHouseState } from './RTBHouse.types';

export const INIT_STATE: RTBHouseState = {
  adAccounts: [],
  adAccountStatuses: {},
  loading: false,
};
